import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { ButtonComponent } from 'app/_shared/components/button/button.component'

@Component({
  selector: 'app-reset-password-success',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './reset-password-success.component.html',
  styleUrl: './reset-password-success.component.scss'
})
export class ResetPasswordSuccessComponent {}
